import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
  markAsExtraFile: boolean;
  consultantId?: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/scan/reviewed',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveScanUnkownReviewed = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveScanUnkownReviewedLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveScanUnkownReviewed;
